/* tslint:disable */
/* eslint-disable */
/**
 * A2B Enrich/Validate API
 * Internal API for enriching/validating common data
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: dev@a2b-internet.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { Country } from '../model';
/**
 * InformationApi - axios parameter creator
 */
export const InformationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieve available countries for use in other API endpoints
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveCountries: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/validate/countries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InformationApi - functional programming interface
 */
export const InformationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InformationApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieve available countries for use in other API endpoints
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrieveCountries(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Country>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrieveCountries(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InformationApi.retrieveCountries']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * InformationApi - factory interface
 */
export const InformationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InformationApiFp(configuration)
    return {
        /**
         * Retrieve available countries for use in other API endpoints
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveCountries(options?: RawAxiosRequestConfig): AxiosPromise<Array<Country>> {
            return localVarFp.retrieveCountries(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * InformationApi - object-oriented interface
 */
export class InformationApi extends BaseAPI {
    /**
     * Retrieve available countries for use in other API endpoints
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public retrieveCountries(options?: RawAxiosRequestConfig) {
        return InformationApiFp(this.configuration).retrieveCountries(options).then((request) => request(this.axios, this.basePath));
    }
}

